export class CalculateComponent {

  protected pdfDataOffert: any;
  protected pdfDataAntrag: any;
 
  resetPdfData() {
    this.pdfDataOffert = null;
    this.pdfDataAntrag = null;
  }

  downloadDocument(pdfData: any, fileName: string): void {
    if (pdfData) {
      const data = window.URL.createObjectURL(pdfData);
      const link = document.createElement('a');
      link.href = data;
      link.download = fileName;
      link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
    }
  }
}
